module.exports = __webpack_public_path__ + "img/note.10803c70.png";